
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import SearchBoxModal from "../component/SearchBoxModal";

const TRANG_THAI = {
    dang_lam: <span className="text-secondary">Đang làm</span>,
    cho_cham: <span className="text-warning">Chờ chấm</span>,
    da_cham: <span className="text-success">Đã chấm</span>,
};

export default function DanhSachBaiLam() {
    const [params, setParam] = useState('');
    const [dethiId, setDethiId] = useState('');
    const [trangThai, setTrangThai] = useState('');
    const [filterShow, setFilterShow] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = '';
        if (dethiId !== '') _param += "&dethi_id=" + dethiId;
        if (trangThai !== '') _param += "&trang_thai=" + trangThai;
        setParam(_param);
    };

    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "hocsinh_name", label: "Thí sinh" },
        { name: "dethi_title", label: "Đề" },
        {
            name: "trang_thai", label: "Trạng thái",
            options: { customBodyRender: (v) => TRANG_THAI[v] || v }
        },
        {
            name: "tong_diem", label: "Điểm",
            options: { customBodyRender: (v, row) => v != null ? `${v} / ${row.dethi_tong_diem}` : `(${row.diem_tu_dong} tạm tính)` }
        },
        {
            name: "time_start", label: "Thời gian làm",
            options: {
                customBodyRender: (v, row) => {
                    if (!v || !row.time_submit || row.time_submit < v) return '-';
                    const s = row.time_submit - v, m = Math.floor(s / 60), ss = s % 60;
                    return (m > 0 ? m + ' phút ' : '') + ss + ' giây';
                }
            }
        },
        {
            name: "id", label: "Chấm / Xem",
            options: {
                customBodyRender: (v, row) => row.trang_thai === 'cho_cham'
                    ? <Link to={"/cham-bai-lam/" + v} className="btn btn-sm btn-warning">Chấm bài</Link>
                    : <Link to={"/cham-bai-lam/" + v} className="btn btn-sm btn-info">Xem</Link>
            }
        },
    ];

    return (<AkkhorLayout idrole="learninghub_bailam">
        <div className="breadcrumbs-area">
            <ul>
                <li><Link to="/">Trang chủ</Link></li>
                <li>Bài làm của thí sinh</li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto"><h3 className="title">Tìm kiếm</h3></div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get">
                    <div className="row">
                        <div className="col-sm-3 col-12 form-group">
                            <label>Đề</label>
                            <SearchBoxModal apiname={"learninghub_dethi"} alldata={"?status=1"} placeholder="Chọn đề" colvalue={'id'} colname={'title'} name='dethi_id'
                                onChange={(e) => setDethiId(e)}></SearchBoxModal>
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Trạng thái</label>
                            <select className="form-select height32" value={trangThai} onChange={(e) => setTrangThai(e.target.value)}>
                                <option value="">Tất cả</option>
                                <option value="cho_cham">Chờ chấm</option>
                                <option value="da_cham">Đã chấm</option>
                            </select>
                        </div>
                        <div className="col-12">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="learninghub_bailam" linkaction="learninghub_bailam" idrole="learninghub_bailam" params={params} defaultLimit={50} serverSide={true} columns={columns} noAction={true}></SRList>
    </AkkhorLayout>);
}
